<template>
<div style="padding-bottom:20px;">
		<mobile-header active="/mobile/companyActive"></mobile-header>
		<h4 style="margin-bottom: 0;" class="font2">招投标专题研究</h4>
		<p class="borderBottom"><span>&nbsp;</span></p>
		<div style="padding:0 20px;">
			<img src="@assets/images/companyActive/公司业务—研究.jpg" style="width: 100%;" />
		</div>
		<div style="padding:0 10px;color: #595959;font-size: 14px;line-height: 25px;">
			<p style="text-indent: 2em;">
				目前承接的招投标专题研究业务有智能辅助评标、投标人画像、围标串标等，通过专注某个专题的研究，为客户提供更深层次的专业解决方案，提升客户招投标管理能力与效率，降低招投标管理风险。
			</p>
		</div>
		
		<div style="margin:40px 0 0 0;text-align: center;">
			<h4 style="margin-bottom: 0;" class="font2">研究领域</h4>
			<p class="borderBottom"><span>&nbsp;</span></p>
			<div style="display: flex;text-align: center;">
				<div style="flex: 1;padding:2px;" v-for="(item,index) in servicesuperiority.slice(0,4)" :key="index">
					<div style="padding:10px 0;">
						<i class="iconfont" v-bind:class="item.icon" style="font-size:30px;color: #409EFF"></i>
						<p style="font-size: 12px;">{{item.title}}</p>
					</div>
				</div>
			</div>
			<div style="display: flex;text-align: center;">
				<div style="flex: 1;padding:2px;" v-for="(item,index) in servicesuperiority.slice(4,8)" :key="index">
					<div style="padding:10px 0;">
						<i class="iconfont" v-bind:class="item.icon" style="font-size:30px;color: #409EFF"></i>
						<p style="font-size: 12px;">{{item.title}}</p>
					</div>
				</div>
			</div>
		</div>

		<div style="margin:40px 0 0 0;text-align: center;">
			<h4 style="margin-bottom: 0;" class="font2">智能评标专题</h4>
			<p class="borderBottom"><span>&nbsp;</span></p>
			<div class="liuCheng">
				<div class="iconDiv">
					<p class="iconfont  white" v-bind:class="project[0].icon"></p>
					<h6>{{project[0].title}}</h6>
				</div>
				<div class="iconDiv2">
					<p class="iconfont icon-jiantou"></p>
				</div>
				<div class="iconDiv">
					<p class="iconfont  white" v-bind:class="project[1].icon"></p>
					<h6>{{project[1].title}}</h6>
				</div>
				<div class="iconDiv2">
					<p class="iconfont icon-jiantou"></p>
				</div>
				<div class="iconDiv">
					<p class="iconfont  white" v-bind:class="project[2].icon"></p>
					<h6>{{project[2].title}}</h6>
				</div>
				<div class="iconDiv2">
					<p class="iconfont icon-jiantou"></p>
				</div>
				<div class="iconDiv">
					<p class="iconfont  white" v-bind:class="project[3].icon"></p>
					<h6>{{project[3].title}}</h6>
				</div>
			</div>
			
			<div class="liuCheng">
				<div class="iconDiv">
					<p class="iconfont  white" v-bind:class="project[4].icon"></p>
					<h6>{{project[4].title}}</h6>
				</div>
				<div class="iconDiv2">
					<p class="iconfont icon-jiantou"></p>
				</div>
				<div class="iconDiv">
					<p class="iconfont  white" v-bind:class="project[5].icon"></p>
					<h6>{{project[5].title}}</h6>
				</div>
				<div class="iconDiv2">
					<p class="iconfont icon-jiantou"></p>
				</div>
				<div class="iconDiv">
					<p class="iconfont  white" v-bind:class="project[6].icon"></p>
					<h6>{{project[6].title}}</h6>
				</div>
				<div class="iconDiv2">
					<p class="iconfont icon-jiantou"></p>
				</div>
				<div class="iconDiv">
					<p class="iconfont  white" v-bind:class="project[6].icon"></p>
					<h6>{{project[6].title}}</h6>
				</div>
			</div>
		</div>
		
		<div style="margin:40px 0 0 0;text-align: center;">
			<h4 style="margin-bottom: 0;" class="font2">投标人画像专题</h4>
			<p class="borderBottom"><span>&nbsp;</span></p>
			<div style="display: flex;">
				<div style="flex: 1;"   v-for="(item,index) in serviceprocessing" :key="index">
					<div style="padding:2px;">
						<img :src="item.src" style="width: 100%;"/>
					</div>
				</div>
			</div>
		</div>
		<!--
		<div style="margin: 50px 0;text-align: center;">
			<h1 style="margin-bottom: 50px;" class="font2">投标人画像专题</h1>
			<h1 class="borderBottom"><span>&nbsp;</span></h1>
			<div style="display: flex;">
				<div style="flex: 1;"   v-for="(item,index) in serviceprocessing" :key="index">
					<div style="padding:5%;">
						<img :src="item.src" style="width: 100%;"/>
					</div>
					
				</div>
			</div>
		</div>
		-->
</div>
</template>
<style scoped>
	.font2{
		background-image: -webkit-gradient( linear, left top, right top, color-stop(0.3, #22f), color-stop(0.6, #2ff) );
		color: transparent;
		-webkit-background-clip: text;
		text-align: center;
	}
	.borderBottom{
		text-align: center;
		margin:0 0 10px 0;
	}
	.borderBottom span{
		border-bottom:#FF8700 3px solid ;
		display: inline-block;
		width: 20px;
	}
	.liuCheng{
		display: flex;background-color:#409EFF;color: #fff;padding:10px;
	}
	.liuCheng .iconDiv{
		flex-grow:3;
		width: 0;
		padding-top: 10px;
	}
	.liuCheng .iconDiv h6{
		margin:5px 0 0 0;
	}
	.liuCheng .iconDiv2{
		flex-grow: 1;
		width: 0;
		padding-top: 10px;
	}
	.liuCheng .iconDiv2 .icon-jiantou{
		font-size:25px;
	}
	.liuCheng .iconDiv .white{
		display:inline-block;
		width: 60px;
		height: 60px;
		line-height: 60px;
		border-radius: 50%;
		font-size:30px;
		background-color: #fff;
		box-sizing: border-box;
		margin: 0;
		color:#409EFF;
	}
</style>
<script>
import mobileHeader from "@components/mobileHeader";
	export default {
		name: 'tenderResearch',
		components: {
			mobileHeader,
		},
  data() {
    return {
      headersrc: require("@assets/image/公司前台.jpg"),
		project:[
			{
			id: 1,
			icon: 'icon-109tiaokuanpeizhi',
			title: "评分条款标准化",
			},
			{
			id: 2,
			icon: 'icon-pingfen',
			title: "评分标准量化",
			},
			{
			id: 3,
			icon: 'icon-jisuanguize',
			title: "制定评分计算规则",
			},
			{
			id: 4,
			icon: 'icon-zidongshengcheng',
			title: "自动生成结构化招标文件",
			},{
			id: 5,
			icon: 'icon-gongnengmokuaihua',
			title: "投标文件结构化响应",
			},
			{
			id: 6,
			icon: 'icon-monikaoshi',
			title: "系统自动评分",
			},
			{
			id: 7,
			icon: 'icon-zhuanjiashenhe',
			title: "专家审核确定评分结果",
			}
		],
      serviceprocessing: [
		{
			src: require("@assets/images/tenderResearch/1.jpg"),
		},
		{
			src: require("@assets/images/tenderResearch/2.jpg"),
		},
		{
			src: require("@assets/images/tenderResearch/3.jpg"),
		},
      ],
      servicesuperiority: [
        {
          id: 1,
          icon: 'icon-zhaotoubiaoguanli',
          title: "招投标管理",
        },
        {
          id: 2,
		icon: 'icon-pingfen',
          title: "智能评标",
        },
        {
          id: 3,
          icon: 'icon-guanliangongsiweibiaochuanbiao',
          title: "围标串标",
        },
        {
          id: 4,
          icon: 'icon-tuisong',
          title: "标讯智能推送",
        },{
          id: 5,
          icon: 'icon-tisheng',
          title: "技能提升",
        },
        {
          id: 6,
          icon: 'icon-toubiaobaojiayingda',
          title: "报价模拟仿真",
        },
        {
          id: 7,
          icon: 'icon-renwuhuaxiangyijiicom',
          title: "投标人画像",
        },
        {
          id: 8,
          icon: 'icon-gongnengmokuaihua',
          title: "更多",
        },
      ],
    };
  },
	mounted:function(){
		this.bus.$emit('headerImg',this.headerImgMobile);
	}
};
</script>
